import React from 'react';

import { POP_IN_V2 } from 'src/featureFlags/currentFlags';
import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';
import { MyDayTodayV2 } from 'src/myDayToday/MyDayTodayV2';
import { LegacyMyDayToday } from 'src/myDayToday/legacy/LegacyMyDayToday';

export const MyDayToday = () => {
  const isV2Enabled = useFeatureFlag(POP_IN_V2);
  return isV2Enabled ? <MyDayTodayV2 /> : <LegacyMyDayToday />;
};
